import {useCallback} from 'react';

import {i18n} from '~ui/components/GridTable/i18n';

export type GridExportFormat = 'csv' | 'xls' | 'docx';

const formats = [
    {title: i18n('settings-download-in-xls'), format: 'xls'},
    {title: i18n('settings-download-in-docx'), format: 'docx'},
    {title: i18n('settings-download-in-csv'), format: 'csv'},
] as const;

export const useGridExport = () => {
    const exportGrid = useCallback((gridId: string, fileFormat: GridExportFormat) => {
        const link = document.createElement('a');
        link.setAttribute('href', `/.grid-export/${gridId}/${fileFormat}`);
        // filename will be used if header Content-Disposition is not sent
        link.setAttribute('download', `grid.${fileFormat}`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, []);

    return {exportGrid, formats};
};
